import React from "react";

export default function ProfileCard({

    title,
    icon,
    children,
    className = ""
}) {

    return (

        <div className={`profile-card card border-0 shadow-sm mb-4 ${className}`}>
            <div className="profile-card-header">
                <div className="d-flex align-items-center">
                    {
                        icon &&
                        <i
                            className={`bi ${icon} profile-card-icon`}
                        ></i>
                    }

                    <h5 className="profile-card-title">

                        {title}

                    </h5>

                </div>

            </div>

            <div className="profile-card-body">

                {children}

            </div>

        </div>

    );

}